import actionTypes from '../constants/action-types';

const setCleanUrlsEnabled = (value) => ({
  type: actionTypes.SET_CLEAN_URL_ENABLED,
  payload: {
    cleanUrlsEnabled: value,
  },
});

export default setCleanUrlsEnabled;
